import React from 'react';
import './DecorativeSquare.css';

export const DecorativeSquare = ({ size = 'md', className = '' }) => {
  const sizeMap = {
    sm: 'w-16 h-16',
    md: 'w-20 h-20',
    lg: 'w-28 h-28',
    xl: 'w-36 h-36'
  };

  return (
    <div className={`decorative-square ${sizeMap[size]} ${className}`}>
      <div className="square-inner"></div>
    </div>
  );
};
